import React, { useEffect, useState } from 'react';
import { useEleccions } from 'hooks/3catinfo/useEleccions';
import PeuEscrutini from 'components/3catinfo/Eleccions/Grafiques/PeuEscrutini';
import clsx from 'clsx';
import styles from './barresVotsDiputats.module.scss';
import BarresVots from '../BarresVots';
import BarresDiputats from '../BarresDiputats';

const BarresVotsDiputats = (props) => {
    const {
        titol,
        urlDades,
        intervalRefresh = 0,
        fase,
        graficSeleccionat = 'vots',
        mostraPeu = true,
        peuMostraCamps = ['participacio', 'vots', 'votsBlanc', 'votsNuls'],
        tipusEleccions = null,
        carrec = 'Regidors'
    } = props;
    const { dataActual, getDades } = useEleccions();
    const percentatgeEscrutini = dataActual?.datos?.geo?.perc_escrutat;

    const [selected, setSelected] = useState(graficSeleccionat);
    const tipusCarrec = tipusEleccions === 'municipals' ? carrec : 'Diputats';
    useEffect(() => {
        if (mostraPeu) {
            getDades({
                urlDades,
                intervalRefresh
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlDades]);

    const stylesDiputats = clsx({
        [styles.switchOption]: true,
        [styles.active]: selected === 'diputats'
    });

    const stylesVots = clsx({
        [styles.switchOption]: true,
        [styles.active]: selected === 'vots'
    });

    const stylesBarresDiputats = clsx({
        [styles.contentBarres]: true,
        [styles.show]: selected === 'diputats'
    });
    const stylesBarresVots = clsx({
        [styles.contentBarres]: true,
        [styles.show]: selected === 'vots'
    });

    return (
        <>
            <div className={styles.contentGrafic}>
                <div className={styles.capcalera}>
                    <div className={styles.titol}>
                        {titol && <h3>{titol}</h3>}
                        {(fase === 'escrutini' || fase === 'final') && Number.isFinite(Number(percentatgeEscrutini)) && (
                            <div className={styles.escrutini}>Escrutini {percentatgeEscrutini}%</div>
                        )}
                    </div>
                    <div className={styles.switchContainer}>
                        <button className={stylesDiputats} onClick={() => setSelected('diputats')}>
                            {tipusCarrec}
                        </button>
                        <button className={stylesVots} onClick={() => setSelected('vots')}>
                            % Vots
                        </button>
                    </div>
                </div>

                <div className={stylesBarresDiputats}>
                    <BarresDiputats
                        {...props}
                        mostraLlegenda={false}
                        mostraPeu={false}
                        mostraTitol={false}
                        className={styles.grafic}
                        mostraEscrutini={false}
                        selected={selected}
                        tipusEleccions={tipusEleccions}
                    />
                </div>

                <div className={stylesBarresVots}>
                    <BarresVots
                        {...props}
                        mostraLlegenda={false}
                        mostraPeu={false}
                        mostraTitol={false}
                        className={styles.grafic}
                        mostraEscrutini={false}
                        selected={selected}
                        limitValueCondition={null}
                        tipusEleccions={tipusEleccions}
                    />
                </div>

                {mostraPeu && <PeuEscrutini data={dataActual?.datos.geo} {...props} peuMostraCamps={peuMostraCamps} />}
            </div>
        </>
    );
};

export default BarresVotsDiputats;
